import { api } from '@/lib/api';

type Query = Record<string, string | number | undefined>;

/**
 * Alle regels van een selectie, pagina voor pagina met de cursor.
 *
 * Voor GET /api/admin/usage/entries en GET /api/me/usage. Met de cursor en niet met
 * offset: het logboek loopt door terwijl er opgehaald wordt, en een nieuwe regel
 * bovenaan schuift bij offset alles een plek op.
 */
export async function haalAlleRegels<T>(
  pad: string,
  query: Query,
  paginagrootte: number,
): Promise<T[]> {
  const alle: T[] = [];
  let cursor: string | undefined;
  do {
    const antwoord = await api.get<{ entries: T[]; nextCursor: string | null }>(pad, {
      query: { ...query, limit: paginagrootte, cursor },
    });
    alle.push(...antwoord.entries);
    cursor = antwoord.nextCursor ?? undefined;
  } while (cursor);
  return alle;
}

/** YYYY-MM als jaar en maand (1-12), voor het maandfilter van de API. */
export function jaarEnMaand(maand: string): { year: number; month: number } {
  const [jaar, nummer] = maand.split('-');
  return { year: Number(jaar), month: Number(nummer) };
}
